import { createSlice } from "@reduxjs/toolkit";
const defaultSelectionValue = { value: "mean", label: "Mean" };

const initialState = {
    overallBoxAnalysisSelection: {},
    secondaryBoxAnalysisSelection: {},
    agreementBoxAnalysisSelection: {},
    claimsBoxAnalysisSelection: {},
    fragranceOverallBoxAnalysisSelection: {},
    fragranceAdditionalBoxAnalysisSelection: {},
    expressCltOverallBoxAnalysisSelection: {},
    expressCltAdditionalBoxAnalysisSelection: {},

    overallBoxAnalysisTypeSelection: [],
    secondaryBoxAnalysisTypeSelection: [],
    agreementBoxAnalysisTypeSelection: [],
    claimsBoxAnalysisTypeSelection: [],
    fragranceOverallBoxAnalysisTypeSelection: [],
    fragranceAdditionalBoxAnalysisTypeSelection: [],
    expressCltOverallBoxAnalysisTypeSelection: [],
    expressCltAdditionalBoxAnalysisTypeSelection: [],
    fragranceAssociationBoxAnalysisTypeSelection: [],

    overallDataViewOptions: [],
    secondaryDataViewOptions: [],
    agreementDataViewOptions: [],
    claimsDataViewOptions: [],
    fragranceOverallDataViewOptions: [],
    fragranceAdditionalDataViewOptions: [],
    expressCltOverallDataViewOptions: [],
    expressCltAdditionalDataViewOptions: [],

    overallAnalysisTypeValue: { ...defaultSelectionValue },
    secondaryAnalysisTypeValue: { ...defaultSelectionValue },
    agreementAnalysisTypeValue: { ...defaultSelectionValue },
    claimsAnalysisTypeValue: { ...defaultSelectionValue },
    fragranceMetricsAnalysisTypeValue: { ...defaultSelectionValue },
    preferenceAnalysisTypeValue: { value: "count", label: "Count" },
    productPreferenceAnalysisTypeValue: { value: "count", label: "Count" },
    fragranceOverallTypeValue: { ...defaultSelectionValue },
    fragranceAdditionalTypeValue: { ...defaultSelectionValue },
    expressCltOverallTypeValue: { ...defaultSelectionValue },
    expressCltAdditionalTypeValue: { ...defaultSelectionValue },
    fragranceAssociationAnalysisTypeValue: { value: "count", label: "Count" },

    overallBoxAnalysisApplyAllSelection: {},
    secondaryBoxAnalysisApplyAllSelection: {},
    agreementBoxAnalysisApplyAllSelection: {},
    claimsBoxAnalysisApplyAllSelection: {},
    fragranceOverallBoxAnalysisApplyAllSelection: {},
    fragranceAdditionalBoxAnalysisApplyAllSelection: {},
    expressCltOverallBoxAnalysisApplyAllSelection: {},
    expressCltAdditionalBoxAnalysisApplyAllSelection: {},
};

export const analysisTypeSelectionStore = createSlice({
    name: "analysisTypeSelectionStore",
    initialState,
    reducers: {
        loadOverallBoxAnalysisSelectionState: (state, action) => {
            state.overallBoxAnalysisSelection = action.payload;
        },
        loadOverallBoxAnalysisTypeSelectionState: (state, action) => {
            state.overallBoxAnalysisTypeSelection = action.payload;
        },
        loadOverallDataViewOptionsState: (state, action) => {
            state.overallDataViewOptions = action.payload;
        },
        loadSecondaryBoxAnalysisSelectionState: (state, action) => {
            state.secondaryBoxAnalysisSelection = action.payload;
        },
        loadAgreementBoxAnalysisSelectionState: (state, action) => {
            state.agreementBoxAnalysisSelection = action.payload;
        },
        loadClaimsBoxAnalysisSelectionState: (state, action) => {
            state.claimsBoxAnalysisSelection = action.payload;
        },
        loadSecondaryBoxAnalysisTypeSelectionState: (state, action) => {
            state.secondaryBoxAnalysisTypeSelection = action.payload;
        },
        loadAgreementBoxAnalysisTypeSelectionState: (state, action) => {
            state.agreementBoxAnalysisTypeSelection = action.payload;
        },
        loadClaimsBoxAnalysisTypeSelectionState: (state, action) => {
            state.claimsBoxAnalysisTypeSelection = action.payload;
        },
        loadSecondaryDataViewOptionsState: (state, action) => {
            state.secondaryDataViewOptions = action.payload;
        },
        loadAgreementDataViewOptionsState: (state, action) => {
            state.agreementDataViewOptions = action.payload;
        },
        loadClaimsDataViewOptionsState: (state, action) => {
            state.claimsDataViewOptions = action.payload;
        },

        loadOverallAnalysisTypeValueState: (state, action) => {
            state.overallAnalysisTypeValue = action.payload;
        },
        loadSecondaryAnalysisTypeValueState: (state, action) => {
            state.secondaryAnalysisTypeValue = action.payload;
        },
        loadAgreementAnalysisTypeValueState: (state, action) => {
            state.agreementAnalysisTypeValue = action.payload;
        },
        loadClaimsAnalysisTypeValueState: (state, action) => {
            state.claimsAnalysisTypeValue = action.payload;
        },
        loadFragranceMetricsAnalysisTypeValueState: (state, action) => {
            state.fragranceMetricsAnalysisTypeValue = action.payload;
        },
        loadPreferenceAnalysisTypeValueState: (state, action) => {
            state.preferenceAnalysisTypeValue = action.payload;
        },
        loadProductPreferenceAnalysisTypeValueState: (state, action) => {
            state.productPreferenceAnalysisTypeValue = action.payload;
        },
        loadOverallBoxAnalysisApplyAllSelectionState: (state, action) => {
            state.overallBoxAnalysisApplyAllSelection = action.payload;
        },
        loadSecondaryBoxAnalysisApplyAllSelectionState: (state, action) => {
            state.secondaryBoxAnalysisApplyAllSelection = action.payload;
        },
        loadAgreementBoxAnalysisApplyAllSelectionState: (state, action) => {
            state.agreementBoxAnalysisApplyAllSelection = action.payload;
        },
        loadClaimsBoxAnalysisApplyAllSelectionState: (state, action) => {
            state.claimsBoxAnalysisApplyAllSelection = action.payload;
        },
        //Overall Analysis clt
        loadFragranceOverallBoxAnalysisSelectionState: (state, action) => {
            state.fragranceOverallBoxAnalysisSelection = action.payload;
        },
        loadFragranceOverallBoxAnalysisTypeSelectionState: (state, action) => {
            state.fragranceOverallBoxAnalysisTypeSelection = action.payload;
        },
        loadFragranceOverallDataViewOptionsState: (state, action) => {
            state.fragranceOverallDataViewOptions = action.payload;
        },
        loadFragranceOverallTypeValueState: (state, action) => {
            state.fragranceOverallTypeValue = action.payload;
        },
        loadFragranceOverallBoxAnalysisApplyAllSelectionState: (state, action) => {
            state.fragranceOverallBoxAnalysisApplyAllSelection = action.payload;
        },
        //ends here
        //Additional Analysis clt
        loadFragranceAdditionalBoxAnalysisSelectionState: (state, action) => {
            state.fragranceAdditionalBoxAnalysisSelection = action.payload;
        },
        loadFragranceAdditionalBoxAnalysisTypeSelectionState: (state, action) => {
            state.fragranceAdditionalBoxAnalysisTypeSelection = action.payload;
        },
        loadFragranceAdditionalDataViewOptionsState: (state, action) => {
            state.fragranceAdditionalDataViewOptions = action.payload;
        },
        loadFragranceAdditionalTypeValueState: (state, action) => {
            state.fragranceAdditionalTypeValue = action.payload;
        },
        loadFragranceAdditionalBoxAnalysisApplyAllSelectionState: (state, action) => {
            state.fragranceAdditionalBoxAnalysisApplyAllSelection = action.payload;
        },
        //ends here

        //Overall analysis Express CLT
        loadExpressCltOverallBoxAnalysisSelectionState: (state, action) => {
            state.expressCltOverallBoxAnalysisSelection = action.payload;
        },
        loadExpressCltOverallBoxAnalysisTypeSelectionState: (state, action) => {
            state.expressCltOverallBoxAnalysisTypeSelection = action.payload;
        },
        loadExpressCltOverallDataViewOptionsState: (state, action) => {
            state.expressCltOverallDataViewOptions = action.payload;
        },
        loadExpressCltOverallTypeValueState: (state, action) => {
            state.expressCltOverallTypeValue = action.payload;
        },
        loadExpressCltOverallBoxAnalysisApplyAllSelectionState: (state, action) => {
            state.expressCltOverallBoxAnalysisApplyAllSelection = action.payload;
        },
        //ends here

        //Additional analysis Express CLT
        loadExpressCltAdditionalBoxAnalysisSelectionState: (state, action) => {
            state.expressCltAdditionalBoxAnalysisSelection = action.payload;
        },
        loadExpressCltAdditionalBoxAnalysisTypeSelectionState: (state, action) => {
            state.expressCltAdditionalBoxAnalysisTypeSelection = action.payload;
        },
        loadFragranceAssociationBoxAnalysisTypeSelectionState: (state, action) => {
            state.fragranceAssociationBoxAnalysisTypeSelection = action.payload;
        },
        loadExpressCltAdditionalDataViewOptionsState: (state, action) => {
            state.expressCltAdditionalDataViewOptions = action.payload;
        },
        loadExpressCltAdditionalTypeValueState: (state, action) => {
            state.expressCltAdditionalTypeValue = action.payload;
        },
        loadFragranceAssociationTypeValueState: (state, action) => {
            state.fragranceAssociationAnalysisTypeValue = action.payload;
        },
        loadExpressCltAdditionalBoxAnalysisApplyAllSelectionState: (state, action) => {
            state.expressCltAdditionalBoxAnalysisApplyAllSelection = action.payload;
        },
        //ends here

        resetAnalysisTypeSelectionStoreState: () => initialState,
    },
});

export const {
    loadOverallBoxAnalysisSelectionState,
    loadSecondaryBoxAnalysisSelectionState,
    loadAgreementBoxAnalysisSelectionState,
    loadClaimsBoxAnalysisSelectionState,
    loadFragranceOverallBoxAnalysisSelectionState,

    loadOverallBoxAnalysisTypeSelectionState,
    loadSecondaryBoxAnalysisTypeSelectionState,
    loadAgreementBoxAnalysisTypeSelectionState,
    loadClaimsBoxAnalysisTypeSelectionState,
    loadFragranceOverallBoxAnalysisTypeSelectionState,
    loadFragranceAssociationBoxAnalysisTypeSelectionState,

    loadOverallDataViewOptionsState,
    loadSecondaryDataViewOptionsState,
    loadAgreementDataViewOptionsState,
    loadClaimsDataViewOptionsState,
    loadFragranceOverallDataViewOptionsState,

    loadOverallAnalysisTypeValueState,
    loadSecondaryAnalysisTypeValueState,
    loadAgreementAnalysisTypeValueState,
    loadClaimsAnalysisTypeValueState,
    loadFragranceMetricsAnalysisTypeValueState,
    loadPreferenceAnalysisTypeValueState,
    loadProductPreferenceAnalysisTypeValueState,
    loadFragranceOverallTypeValueState,

    loadOverallBoxAnalysisApplyAllSelectionState,
    loadSecondaryBoxAnalysisApplyAllSelectionState,
    loadAgreementBoxAnalysisApplyAllSelectionState,
    loadClaimsBoxAnalysisApplyAllSelectionState,
    loadFragranceOverallBoxAnalysisApplyAllSelectionState,

    loadFragranceAdditionalBoxAnalysisApplyAllSelectionState,
    loadFragranceAdditionalBoxAnalysisSelectionState,
    loadFragranceAdditionalBoxAnalysisTypeSelectionState,
    loadFragranceAdditionalDataViewOptionsState,
    loadFragranceAdditionalTypeValueState,

    loadExpressCltOverallBoxAnalysisSelectionState,
    loadExpressCltOverallBoxAnalysisTypeSelectionState,
    loadExpressCltOverallDataViewOptionsState,
    loadExpressCltOverallTypeValueState,
    loadExpressCltOverallBoxAnalysisApplyAllSelectionState,

    loadExpressCltAdditionalBoxAnalysisSelectionState,
    loadExpressCltAdditionalBoxAnalysisTypeSelectionState,
    loadExpressCltAdditionalDataViewOptionsState,
    loadExpressCltAdditionalTypeValueState,
    loadFragranceAssociationTypeValueState,
    loadExpressCltAdditionalBoxAnalysisApplyAllSelectionState,

    resetAnalysisTypeSelectionStoreState,
} = analysisTypeSelectionStore.actions;

export default analysisTypeSelectionStore.reducer;
